<a routerLink="/analyst/home" routerLinkActive="active" id="analyst_home" [attr.aria-current]="isActive('/analyst/home') ? 'page' : 'false'">
  <i class="fas fa-house"></i>
  <span>{{'Home' | translate}}</span>
</a>
<a routerLink="/analyst/statistics" routerLinkActive="active" id="analyst_statistics" [attr.aria-current]="isActive('/analyst/statistics') ? 'page' : 'false'">
  <i class="fas fa-chart-pie"></i>
  <span>{{'Statistics' | translate}}</span>
</a>
